module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "privacy"
  }, [_c('el-dialog', {
    attrs: {
      "visible": _vm.privacy,
      "title": "隐私政策"
    },
    on: {
      "update:visible": function($event) {
        _vm.privacy = $event
      }
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v("关闭")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ac72ee9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui/AgreementSign/Privacy.vue
// module id = 177
// module chunks = 0